import { useRecordContext } from 'react-admin';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { colorChoices } from '@/constants/TagCategoryColorChoices';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

const getShade50 = color => {
    if (!color) return 'gray';
    const colorChoice = colorChoices.find(choice => choice.id === color);
    return colorChoice?.shades?.[50] || 'gray';
};

const StyledTagsChip = styled(Typography)(() => ({
    padding: '8px 16px',
    borderRadius: '10px',
    [`@media (max-width: ${breakpoints.values.md}px)`]: {
        padding: '4px 8px',
        borderRadius: '8px',
        fontSize: '12px !important',
        lineHeight: '18px !important',
    },
}));

const smallChipStyles = onClick => ({
    '& .MuiTypography-root': {
        padding: '4px 12px',
        lineHeight: '16px !important',
        borderRadius: '8px !important',
        fontSize: '11px !important',
        ...(onClick ? { '&:hover': { backgroundColor: Palette.violet.violet100 } } : {}),
    },
});

const CustomChipField = ({ onClick, sx, source = 'name', shades = false, color, small = false }) => {
    const record = useRecordContext();
    if (!record) return null;

    const handleClick = e => {
        if (onClick) {
            e.stopPropagation();
            onClick(record, e);
        }
    };

    return (
        <Box
            onClick={handleClick}
            onKeyDown={onClick ? () => {} : undefined}
            sx={{ cursor: onClick ? 'pointer' : 'default', ...(small ? smallChipStyles(onClick) : {}), ...sx }}
            aria-disabled={!onClick}
            className='MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineNone RaLink-link RaSingleFieldList-link'
        >
            {shades ? (
                <StyledTagsChip sx={{ backgroundColor: color || getShade50(record?.category?.color), textWrap: 'nowrap' }}>{record[source]}</StyledTagsChip>
            ) : (
                <Box
                    component='span'
                    sx={{
                        backgroundColor: color || record?.category?.color || 'gray',
                    }}
                >
                    {record[source]}
                </Box>
            )}
        </Box>
    );
};

CustomChipField.propTypes = {
    onClick: PropTypes.func,
    sx: PropTypes.object,
    source: PropTypes.string,
    shades: PropTypes.bool,
    color: PropTypes.string,
    small: PropTypes.bool,
};

export default CustomChipField;
